import React from 'react';
import store from 'javascripts/store.js';
import t from 'javascripts/utils/translation';
import {observer} from 'mobx-react';

@observer
class DonateFormIhoToggle extends React.Component {
  handleIhoClick = () => {
    if(!this.props.validateForm()) { return false; }
    store.iho.modalOpen = true;
  };

  shouldNotRender = () => (
    !store.donateForm.acceptsIho ||
    store.donateForm.onlyAcceptsIho ||
    store.iho.honoreeInfoIsPresent
  );

  render() {
    if(this.shouldNotRender()) return null;

    return(
      <a
        className='iho-toggle'
        onClick={this.handleIhoClick}
      >
        <i className='cw-icon-caretright' />
        &nbsp;
        {t('views.donate_form.iho.toggle')}
      </a>
    );
  }
}

export default DonateFormIhoToggle;
